// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","AnnouncementContent":"AnnouncementContent-2t78kr3tc39nmhwe9fqphvqhwz3arap3n3ajd6qeeny4wmmqkaynzp5pk37jx1vwmkr3dq9cvktb4tv1x8qsxxtr27mms3m2jgyyuwz","loading":"loading-4sykzyr5wa9cj2eacewbmxv1a8dm24yuf696vcc9nwbn2w9jmmcxz8epgvxyja958r21egdhuemzhjyu3hh61ncxz28gqcn9s8eze3w","pulse":"pulse-2wjf9w79phzka6kbm6at42puatthb4jeekvm88jsrrhw9wz237kh91kvrtakzh4bt35deqjfn7mcdx3kw6v6w8fceedn1pxzgmaby4s"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Announcement/AnnouncementView.module.scss
// module id = 1694
// module chunks = 0